<div class="container pt-3">
    <app-voranmeldung-button></app-voranmeldung-button>

    <app-filter [actionButtons]="actionButtons" [categories]="categories" [(query)]="query"
                (queryChange)="updateFilter()"></app-filter>

    <ng-container *ngIf="!isMa">

        <ng-container *ngFor="let aktion of aktionen; let i = index;let first = first;">
            <ng-container *ngIf="!first  && aktion.start < aktionen[i-1].start">
                <hr>
                <h5 class="text-center">Aktionen in der Vergangenheit</h5>
                <hr>
            </ng-container>

            <div class="d-flex my-3 grayBgColor rounded pcBorder overflow-hidden w-100 flex-md-row flex-column align-items-stretch">
                <div class="black datetime-col d-flex flex-md-column flex-row pcBorderRight align-items-stretch">
                    <div class="primaryBgColor timeBox d-flex flex-column p-2 flex-grow-1">
                        <div>Datum</div>
                        <div class="large align-self-center flex-grow-1 d-flex">
                            <div class="align-self-center text-center">{{ aktion | aktionDate:"date" }}</div>
                        </div>
                    </div>
                    <div class="primaryBgColor timeBox d-flex flex-column my-md-1 p-2 flex-grow-1">
                        <div>Start</div>
                        <div class="large align-self-center flex-grow-1 d-flex">
                            <div class="align-self-center text-center">{{ aktion | aktionDate:"timeStart" }}</div>
                        </div>
                    </div>
                    <div class="primaryBgColor timeBox d-flex flex-column p-2 flex-grow-1">
                        <div>Ende</div>
                        <div class="large align-self-center flex-grow-1 d-flex">
                            <div class="align-self-center text-center">{{ aktion | aktionDate:"timeEnd" }}</div>
                        </div>
                    </div>
                </div>
                <div class="d-flex details-col flex-column">
                    <div class="d-flex flex-row pcBorderBottom">
                        <div class="ml-2 mr-auto large">{{ aktion.titel }}</div>
                        <img [src]="aktion.icon?.icon" alt="" class="icon align-self-center align-middle mx-3"
                             width="32" height="32">
                        <div class="id mr-1">{{ aktion.id }}</div>
                    </div>
                    <div class="p-2 flex-grow-1 whitespace-pre">{{ aktion.beschreibung }}</div>
                    <div class="flex-grow-0 p-2 pcBorderTop" *ngIf="!!aktion.mitzubringen">
                        <h5 class="mb-0 mt-2 pb-0">Mitzubringen:</h5>
                        <span class="whitespace-pre">{{ aktion.mitzubringen }}</span>
                    </div>
                    <div class="p-2 pcBorderTop">
                        Veranstalter: {{ aktion.veranstalter }}
                    </div>
                    <div class="d-flex flex-md-row flex-column justify-content-between pcBorderTop infoBar p-2">
                        <div>
                            Ort: {{ aktion.ort }}
                        </div>
                        <div class="pointer" [ngbTooltip]="anmeldestatusTooltip">
                            Anmeldestatus: <span [class]="getClass(aktion)"><i class="fa-solid fa-circle"></i></span>
                            <ng-template #anmeldestatusTooltip>
                                <div class="text-left">
                                    <i class="fa-solid fa-circle green"></i> Plätze frei<br>
                                    <i class="fa-solid fa-circle yellow"></i> Fast voll <br>
                                    <i class="fa-solid fa-circle red"></i> Alle Plätze belegt
                                </div>
                            </ng-template>
                        </div>
                    </div>
                    <div class="d-flex flex-row justify-content-around primaryBgColor black bottomBar">
                        <div class="align-self-center">
                            Preis: {{ aktion.preis.toFixed(2) }} €
                        </div>
                        <div class="align-self-center">
                            Sozialpreis: {{ aktion.soziPreis.toFixed(2) }} €
                        </div>
                        <div class="align-self-center">
                            Alter: {{ aktion | aktionAlter }}
                        </div>
                    </div>
                </div>
            </div>
        </ng-container>

        <div class="mb-3">
            <span class="green"><i class="fa-solid fa-circle"></i> Plätze Frei</span> | <span class="yellow"><i
                class="fa-solid fa-circle"></i> Fast Voll</span> | <span class="red"><i class="fa-solid fa-circle"></i> Alle Plätze belegt</span>
        </div>
    </ng-container>
</div>
<table *ngIf="isMa" class="table text-center">
    <tr>
        <th>ID</th>
        <th>Datum</th>
        <th>Titel</th>
        <th>Alter</th>
        <th>Preis</th>
        <th>Sozialpreis</th>
        <th>Anmeldungen</th>
        <th>Aktiv</th>
        <th></th>
    </tr>
    <ng-container *ngFor="let a of aktionen; let i = index;let first = first;">
        <ng-container *ngIf="!first && a.start < aktionen[i-1].start">
            <tr>
                <td colspan="9"><b>Aktionen in der Vergangenheit</b></td>
            </tr>
        </ng-container>
        <tr [class]="getClass(a)" id="a{{a.id}}">
            <td class="align-middle">{{ a.id }}</td>
            <td class="align-middle">{{ a | aktionDate:"all" }}</td>
            <td class="align-middle">{{ a.titel }}</td>
            <td class="align-middle">{{ a | aktionAlter }}</td>
            <td class="align-middle">{{ a.preis.toFixed(2) }} €</td>
            <td class="align-middle">{{ a.soziPreis.toFixed(2) }} €</td>

            <td class="align-middle text-center anzahl" *ngIf="aktionList(a) as list">
                <span ngbTooltip="Voranmeldung" class="grau">{{ list.vor }}</span>
                <span ngbTooltip="Angemeldet" class="blau">{{ list.ang }}</span>
                <span ngbTooltip="Warteliste" class="gelb">{{ list.wList }}</span>
                <span ngbTooltip="Gebucht" class="gruen">{{ list.geb }}</span>
                /
                <span ngbTooltip="Max. Teilnehmer" class="primaryBgColor">{{ a.maxKinder }}</span>
            </td>

            <td class="align-middle"><input type="checkbox" disabled [checked]="a.aktiv" class="largeCheckbox"></td>
            <td class="align-middle">
                <button class="btn pcButton mx-2" ngbTooltip="Bearbeiten" [routerLink]="'/aktion/edit/' + a.id"><i
                        class="fas fa-edit"></i></button>
                <button class="btn pcButton mx-2" ngbTooltip="Kosten" [routerLink]="'/aktion/cost/' + a.id"><i
                        class="fas fa-euro-sign"></i></button>
                <button class="btn pcButton mx-2" ngbTooltip="Anmeldungsliste"
                        [routerLink]="'/aktion/kinderList/' + a.id"><i class="fas fa-list"></i></button>
            </td>
        </tr>
    </ng-container>
</table>
